// @flow

import React, { type Node } from 'react';
import { getSafeBoletoUrl, usePendingIncomingPayment, redirectIfCheckForConfirmationIsEnabled } from '@tectonics/prs/incoming-payment';
import styled from 'styled-components';
import { Button } from '../../../atoms';

export function ShowBoletoButton(): Node {
  const incomingPayment = usePendingIncomingPayment();
  return (
    <LinkButton type="primary" flat as="a" target="blank" href={getSafeBoletoUrl(incomingPayment)} data-test-id="action_boleto" onClick = { () => redirectIfCheckForConfirmationIsEnabled(incomingPayment)}>Ver boleto</LinkButton>
  );
}

const LinkButton = styled(Button)`
  width: 48%;
  ::after {
    content: '${({contentMobile}) => contentMobile}';
    @media (min-width: 840px) {
      content: '${({contentDesktop}) => contentDesktop}';
    }
  }
`;
